import axios, { AxiosError } from "axios";
import { displayNoConnection, displayNotify } from "../../../shared/services/Notifications/NotificationServices";
import { ILoginRequest, IRegisterRequest } from "../utils/types";
import { navigate } from "../../../shared/services/NavigationService";

export const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
  return null;
};

class AuthService {
  async authFetch(form: ILoginRequest) {

    const res = await axios.post("/auth/sessions/", form);

    const csrfToken = getCookie("csrftoken");
    axios.defaults.headers.common["X-CSRFToken"] = csrfToken;

    if (res?.data) {
      localStorage.setItem("username", res.data.username);
    }

    return res;
  }

  async changePasswordFetch(email: string) {
    const res = await axios.post("auth/password-reset-requests/", { email });
    return res;
  }

  async setNewPasswordFetch(token: string, new_password: string) {
    const res = await axios.post("auth/password-resets/", { token, new_password });
    return res;
  }

  async regFetch(form: IRegisterRequest) {
    const res = await axios.post("users/", form);

    if (res?.data && res.status === 201) {
      const { login, email, user_callsign } = res.data;
      if (login) localStorage.setItem("username", login);
      if (email) localStorage.setItem("email", email);
      if (user_callsign) localStorage.setItem("user_callsign", user_callsign);

      await this.authFetch({
        login: form.username,
        password: form.password,
      });
    }

    return res;
  }

  async quitFetch() {
    const res = await axios.post("auth/sessions/current/");
    return res;
  }
}

const authService = new AuthService();

function getReturnTo() {
  const params = new URLSearchParams(window.location.search)
  const returnTo = params.get('return_to')

  return returnTo || (window.location.pathname + window.location.search)
}

export function redirectToLogin() {
  if (window.location.pathname !== '/login') {
    const returnTo = getReturnTo()
    window.location.href = '/login?return_to=' + encodeURIComponent(returnTo)
  }
}

export function redirectToRegistration() {
  if (window.location.pathname !== '/register') {
    const returnTo = getReturnTo()
    window.location.href = '/register?return_to=' + encodeURIComponent(returnTo)
  }
}

export function clearUserData() {
  localStorage.removeItem("username");
  localStorage.removeItem("email");
  localStorage.removeItem("user_callsign");
  localStorage.removeItem("callsign");
}

const codeDescriptions: any = {
  ok: { status: "success", description: "Выход удался" },
  error: { status: "error", description: "Выход не удался" },
};

export function initiateLogout() {
  let notifyContent = { title: "Киберштаб" };

  authService
    .quitFetch()
    .then(() => {
      clearUserData();
      redirectToLogin();
      displayNotify({ ...notifyContent, ...codeDescriptions["ok"] });
    })
    .catch((error: AxiosError) => {
      if (error?.response?.status === 504) {
        displayNoConnection()
        return
      }
      displayNotify({ ...notifyContent, ...codeDescriptions["error"] });
    });
}

export default authService;

export function getLogin() {
  return localStorage.getItem('username') || null
}

export function isAuthorized() {
  return typeof localStorage.getItem('username') === typeof ''
}

export function isUserLogin(login: string) {
  return !!login && login === getLogin();
}

export function processIfRegistered(callback: Function) {
  if (isAuthorized())
    callback()
  else
    redirectToLogin()
}
